import { PlatformAndroidService } from './platform-android.service';
import { PlatformWebService } from './platform-web.service';
import { PlatformService } from './platform.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { GlobalErrorHandler } from 'src/app/shared/errors/global-error-handler';

const PlatformServiceFactory = (httpClient: HttpClient, apiService: ApiService/*, globalErrorHandler: GlobalErrorHandler*/) =>    
    isAndroidApp() ? 
    new PlatformAndroidService(httpClient, apiService/*, globalErrorHandler*/) : new PlatformWebService(httpClient, apiService);


const isAndroidApp = (): boolean => {
    const androidApp = localStorage.getItem('ANDROID_APP');
    const androidId = localStorage.getItem('ANDROID_ID');
    //return !!androidApp && !!androidId;
    return window.location.href.lastIndexOf("https://appassets.androidplatform.net") > -1;
}

export const PlatformServiceProvider = { 
    provide: PlatformService,
    useFactory: PlatformServiceFactory,
    deps: [HttpClient, ApiService/*, GlobalErrorHandler*/]
};